// import {
//   Backdrop,
//   Box,
//   Button,
//   CircularProgress,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Drawer,
//   Menu,
//   MenuItem,
//   Typography,
// } from "@mui/material";
// import Pusher from "pusher-js";
// import MobileNavbar from "../mobileNavbar";
// import React, { useEffect, useRef, useState } from "react";
// import noImageAvailable from "../../../images/No_Image_Available.jpg";
// import {
//   FCM_TOKEN,
//   fetchWalletBalance,
//   getAuthMobile,
//   getGustAuthMobile,
//   getLocalStorageMenuItem,
//   ISDARKTHEME,
//   sendNotificationFirebaseRes,
//   setLocalStorageMenuItem,
//   setMobileBackColor,
//   setMobileButttonBackColor,
//   setMobileCardBorderColor,
//   setMobileCardColor,
//   setMobileTextColor,
//   setMobileTextField_BK_FONT_Border_StyleColor,
// } from "../../../utility";
// import axios from "axios";
// import { ScrollMenu } from "react-horizontal-scrolling-menu";
// import "react-horizontal-scrolling-menu/dist/styles.css";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { useQuery } from "react-query";
// import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
// import DarkModeIcon from "@mui/icons-material/DarkMode";
// import LightModeIcon from "@mui/icons-material/LightMode";
// import Snapchat from "../../../images/snapchat.svg";
// import Facebook from "../../../images/facebook-icon.svg";
// import Twitter from "../../../images/twitter.svg";
// import Instagram from "../../../images/instigram.svg";
// import Global from "../../../images/global.svg";

// import FacebookDarkTheme from "../../../images/facebook-icon-dark-theme.svg";
// import TwitterDarkTheme from "../../../images/x-icon-dark-theme.svg";
// import InstagramDarkTheme from "../../../images/insta-icon-dark-theme.svg";
// import WhatsappDarkTheme from "../../../images/whatsapp-icon-dark-theme.svg";
// import MapDarkTheme from "../../../images/map-dark-icon-theme.svg";
// import GlobalDarkTheme from "../../../images/global-icon-dark-theme.svg";
// import Tiktok_Dark from "../../../images/tiktok_dark.svg";
// import Whatsapp from "../../../images/whatsapp.svg";
// import SnapchatDarkTheme from "../../../images/snap-icon-dark-theme.svg";
// import Tiktok_Light from "../../../images/tiktok_light.svg";

// import { CloseOutlined, CreditCard, TranslateOutlined } from "@mui/icons-material";
// import { t } from "i18next";
// import Loading from "../../../common/loading";
// import { Badge } from "react-bootstrap";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import addNotification from "react-push-notification";
// import Toast from "../../../common/toast";

// const Top = ({
//   qrCode,
//   qrName,
//   updateTreeData,
//   handleLanguage,
//   currentId,
//   parentId,
//   currentSectionId,
//   mianSectionsData,
//   detailsData,
//   lablesData,
//   handleOnClick,
//   handleParentSection,
//   handleParent,
//   backToMain,
//   width,
//   order_ability,
//   label_name,
//   itemsRefetch,
//   isMobile,
//   isDesktop
// }) => {
//   const mode = getLocalStorageMenuItem("theme");
//   const language = getLocalStorageMenuItem("lang");
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [state, setState] = useState({ right: false });
//   const [params, setParams] = useSearchParams();
//   const navigate = useNavigate();
//   const sectionRefs = useRef([]);

//   const [anchorlang, setAnchorlang] = useState(null);
//   const openLang = Boolean(anchorlang);
//   const [loadingTree, setLoadingTree] = useState(false);

//   // Determine which mode we're in based on available props/data
//   const isMainMode = mianSectionsData?.tree?.tree && handleOnClick;
//   const isSectionMode = mianSectionsData?.sections?.sections && handleParentSection;

//   const [customerBalance, setCustomerBalance] = useState(getLocalStorageMenuItem("customer_balance") || 0);

//   const [showInfoDailog, setShowInfoDailog] = useState(false);

//   const [toastSettings, setToastSettings] = useState({
//     open: false,
//     message: "",
//     success: false,
//   });

//   const [openMyCards, setOpenMyCards] = useState(false);
//   const [showAddCard, setShowAddCard] = useState(false);

//   const [myCards, setMyCards] = useState(
//     getLocalStorageMenuItem("my_cards") || []
//   );

//   const saveCardToLocal = (card) => {
//     const updated = [...myCards, card];
//     setMyCards(updated);
//     setLocalStorageMenuItem("my_cards", updated);
//     setShowAddCard(false);
//   };

//   const initSaveCardPixel = async () => {
//     if (!window.Pixel) return;

//     const res = await axios.post(
//       `${process.env.REACT_APP_API}/payment-intention`,
//       { amount: 0 },
//       {
//         headers: {
//           Authorization: `Bearer ${getLocalStorageMenuItem("mobileLoginToken")}`,
//           "Content-Type": "application/json",
//         },
//       }
//     );
//     console.log("payment intention res", res);

//     const { public_key, client_secret } = res.data.data;

//     const container = document.getElementById("paymob-save-card-container");
//     if (container) container.innerHTML = "";

//     new window.Pixel({
//       publicKey: public_key,
//       clientSecret: client_secret,
//       elementId: "paymob-save-card-container",
//       paymentMethods: ["card"],

//       onSuccess: (res) => {
//         if (res?.card) {
//           saveCardToLocal(res.card);
//         }
//       },
//     });
//   };



//   const handleOpenToast = (message, state) => {
//     setToastSettings({
//       open: true,
//       success: state,
//       message: message
//     });
//   };

//   const handleCloseToast = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }

//     setToastSettings({ open: false, message: "", success: false });
//   };

//   const handleClickLang = (event) => {
//     setAnchorlang(event.currentTarget);
//   };

//   const handleCloseLang = () => {
//     setAnchorlang(null);
//   };

//   const getDeviceType = () => {
//     const userAgent = navigator.userAgent;
//     if (/iPhone/i.test(userAgent)) {
//       return "iPhone";
//     } else if (/Android/i.test(userAgent)) {
//       return "Android";
//     } else {
//       return "Other";
//     }
//   };

//   const handleOnNavClick = (index) => {
//     if (handleOnClick) {
//       handleOnClick(index);
//     }
//   };



//   useEffect(() => {
//     const deviceType = getDeviceType();
//     const handleScroll = () => {
//       if (sectionRefs.current[currentSectionId]) {
//         sectionRefs.current[currentSectionId].scrollIntoView({
//           behavior: "smooth",
//           inline: "center",
//         });
//       }
//     };

//     if (deviceType === "iPhone") {
//       if (sectionRefs.current[currentSectionId]) {
//         sectionRefs.current[currentSectionId].scrollIntoView({
//           behavior: "smooth",
//           block: "start",
//           inline: "nearest",
//         });
//       }
//     } else {
//       if (sectionRefs.current[currentSectionId]) {
//         sectionRefs.current[currentSectionId].scrollIntoView({
//           behavior: "smooth",
//           block: "start",
//           inline: "nearest",
//         });
//       }
//     }
//   }, [currentSectionId, sectionRefs]);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.pageYOffset > 0) {
//         setIsScrolled(true);
//       } else {
//         setIsScrolled(false);
//       }
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   useEffect(() => {
//     const pusher = new Pusher("ae14bac927c237af424c", {
//       cluster: "mt1",
//       auth: getGustAuthMobile(),
//     });

//     const channel = pusher.subscribe(
//       `customer_notifications.${getLocalStorageMenuItem("gustToken")}`
//     );

//     channel.bind("App\\Events\\NotificationRespond", (data) => {
//       addNotification({
//         title: data.title,
//         message: data.message,
//         duration: 8000,
//         icon: detailsData?.logo || noImageAvailable,
//         native: true,
//       });
//     });

//     return () => {
//       pusher.unsubscribe("customer_notifications");
//       pusher.disconnect();
//     };
//   }, []);

//   useEffect(() => {

//     const fetchCust_Balance = async () => {
//       const newBalance = await fetchWalletBalance();
//       setCustomerBalance(newBalance);
//     }

//     fetchCust_Balance();

//   }, [])

//   const {
//     data: languagesData,
//     isLoading: languagesIsLoading,
//     isError: LanguagesIsError,
//     error: languagesError,
//   } = useQuery("languages", () => {
//     const timeZone = getLocalStorageMenuItem("timezone")
//       ? getLocalStorageMenuItem("timezone")
//       : "";

//     try {
//       return axios.get(
//         `${process.env.REACT_APP_API}/menus/${qrCode}/public-languages`,
//         {
//           headers: {
//             localization: getLocalStorageMenuItem("lang"),
//             timeZone: timeZone.replace(/["]+/g, ""),
//           },
//         }
//       );
//     } catch (error) { }
//   });

//   useEffect(() => {
//     const validateLanguage = () => {
//       if (languagesData?.data?.data?.languages?.length > 0) {
//         const availableLanguages = languagesData.data.data.languages.map(lang => lang.code);
//         const currentLanguage = getLocalStorageMenuItem("lang");

//         // If current language is not in available languages, set to first available language
//         if (!availableLanguages.includes(currentLanguage)) {
//           const firstLanguage = availableLanguages[0];
//           setLocalStorageMenuItem("lang", firstLanguage);
//           handleLanguagedata(firstLanguage);
//         }
//       }
//     };

//     if (languagesData && !languagesIsLoading) {
//       validateLanguage();
//     }
//   }, [languagesData, languagesIsLoading]);

//   const handleFeedBack = () => {
//     navigate(
//       `/${qrName}/${qrCode}/feedback?section=${currentId}&t=${params.get("t")}`
//       , {
//         replace: true
//       });
//   };

//   const handlePrivacyPolicy = () => {
//     navigate(`/${qrName}/${qrCode}/privacy-policy`, {
//       replace: true
//     });
//   };

//   const handleTermsAndConditions = () => {
//     navigate(`/${qrName}/${qrCode}/terms-and-conditions`, {
//       replace: true
//     });
//   };

//   const handleHome = () => {
//     const baseUrl = `/${qrName}/${qrCode}/menus?lang=${language}`;
//     const tableParam = params.get("t");
//     navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl, {
//       replace: true
//     });
//   };

//   const handleProfile = () => {
//     const baseUrl = `/${qrName}/${qrCode}/profile?lang=${language}`;
//     const tableParam = params.get("t");
//     navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl, {
//       replace: true
//     });
//   };

//   const handleLogout = async () => {
//     await setLocalStorageMenuItem("mobileLoginToken", "");
//     const baseUrl = `/${qrName}/${qrCode}/menus?lang=${language}`;
//     const tableParam = params.get("t");
//     navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl, {
//       replace: true
//     });
//   };

//   const handleFavorites = () => {
//     navigate(
//       `/${qrName}/${qrCode}/favorites?section=${currentId}&t=${params.get("t")}`
//       , {
//         replace: true
//       });
//   };

//   const handleOrders = () => {
//     navigate(
//       `/${qrName}/${qrCode}/orders?section=${currentId}&t=${params.get(
//         "t"
//       )}&lang=${language}`
//       , {
//         replace: true
//       });
//   };

//   const handleTransactions = () => {
//     navigate(
//       `/${qrName}/${qrCode}/transactions?section=${currentId}&t=${params.get(
//         "t"
//       )}&lang=${language}`
//       , {
//         replace: true
//       });
//   }

//   const onImageError = (e) => {
//     e.target.src = noImageAvailable;
//   };

//   const hanldeMode = () => {
//     if (getLocalStorageMenuItem("theme") === "dark") {
//       setLocalStorageMenuItem("theme", "light");
//       params.set("theme", "light");
//       setParams(params);
//     } else {
//       setLocalStorageMenuItem("theme", "dark");
//       params.set("theme", "dark");
//       setParams(params);
//     }
//   };

//   const handleSocialPage = (page) => {
//     window.open(page, "_blank");
//   };

//   const handleLanguagedata = async (langCode) => {
//     setLoadingTree(true);
//     try {
//       const timeZone = getLocalStorageMenuItem("timezone") || "";
//       const promise = await axios.get(
//         `${process.env.REACT_APP_API}/menus/${qrCode}/public-tree?table=${params.get('t') || null}`,
//         {
//           headers: {
//             localization: langCode,
//             timeZone: timeZone.replace(/["]+/g, ""),
//           },
//         }
//       );
//       await setLocalStorageMenuItem(
//         "tree_data",
//         JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
//       );
//       await updateTreeData(promise?.data?.data || []);

//       handleLanguage(langCode);
//       itemsRefetch();
//     } catch (error) {
//       // Handle error
//     } finally {
//       setLoadingTree(false);
//     }
//   };

//   const handleSendNotification = async (title, body) => {
//     setLoading(true);
//     try {
//       const sendNotificationRes = await axios.post(
//         `${process.env.REACT_APP_API}/general-notification`,
//         {
//           venue_id: detailsData?.venue_id,
//           title: title || "",
//           message: body || "",
//           table: params.get("t") || "",
//         }
//       );

//       const sendNotificationFirebase = await sendNotificationFirebaseRes(
//         detailsData,
//         title || "",
//         body || "",
//         "notifications"
//       );

//       if (
//         sendNotificationRes?.data?.success &&
//         sendNotificationFirebase?.data?.success
//       ) {
//         setLoading(false);

//         // handleOpenToast(
//         //   <div className="alignByLang">
//         //     {t("Your notification sent successfully")}
//         //   </div>
//         //   , true);

//         setShowInfoDailog(true);
//       } else {
//         setLoading(false);

//         handleOpenToast(
//           <div className="alignByLang">
//             {t("Error while sending the notification.")}
//           </div>
//           , false);
//       }
//     } catch (error) {
//       setLoading(false);

//       handleOpenToast(
//         <div className="alignByLang">
//           {t("Error while sending the notification.") + " " + error.message}
//         </div>
//         , false);
//     }
//   };

//   const list = (anchor) => (
//     <Box
//       sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 350 }}
//       role="presentation"
//       onKeyDown={toggleDrawer(anchor, false)}
//     >
//       <div
//         className={`mobile-side-bar min-vh-100`}
//         style={{
//           color: setMobileTextColor(),
//           backgroundColor: setMobileCardColor(),
//         }}
//       >
//         <div className="d-flex justify-content-between mobile-side-bar-top-settings p-4 sub-font">


//           <div>
//             <img
//               src={detailsData?.logo || noImageAvailable}
//               alt="logo"
//               style={{ border: `4px solid ${setMobileCardColor()} ` }}
//               className="mobile-side-bar-logo"
//               onError={onImageError}
//             />
//             {/* Add name and balance from localStorage */}

//             {getLocalStorageMenuItem("mobileLoginToken") && (
//               <div className="mt-2 text-center" style={{ color: setMobileTextColor() }}>
//                 <div className="sub-font alignByLang text-center">
//                   {t("Welcome")} {getLocalStorageMenuItem("customer_name")}
//                 </div>
//                 <div className="sub-font alignByLang text-center">
//                   {t("Your Balance")} : {getLocalStorageMenuItem("customer_balance") || 0}
//                 </div>
//               </div>
//             )}
//           </div>


//           <div className="d-flex justify-content-between">
//             <div>
//               <span
//                 className="mx-2 pt-0 cursor"
//                 onClick={toggleDrawer(anchor, false)}
//               >
//                 <CloseOutlined style={{ color: setMobileTextColor() }} />
//               </span>
//               <span className="mx-2 pt-0 cursor" onClick={handleClickLang}>
//                 <TranslateOutlined style={{ color: setMobileTextColor() }} />
//               </span>
//               <Menu
//                 id="long-menu"
//                 MenuListProps={{
//                   "aria-labelledby": "long-button",
//                 }}
//                 anchorEl={anchorlang}
//                 open={openLang}
//                 onClose={handleCloseLang}
//                 onClick={handleCloseLang}
//                 PaperProps={{
//                   style: {
//                     maxHeight: 48 * 4.5,
//                     width: "25ch",
//                     backgroundColor: setMobileBackColor(),
//                   },
//                 }}
//               >

//                 {languagesData?.data?.data?.languages?.map((lang) => {
//                   const currentLang = getLocalStorageMenuItem("lang");
//                   const isSelected = lang.code === currentLang;

//                   return (
//                     <MenuItem
//                       key={lang.code}
//                       onClick={() => handleLanguagedata(lang.code)}
//                     >
//                       <li
//                         className="d-flex justify-content-between align-items-center p-1 sub-font"
//                         style={{
//                           color: isSelected
//                             ? setMobileButttonBackColor()
//                             : setMobileTextColor(),
//                         }}
//                       >
//                         <span style={{ maxWidth: "80%" }}>
//                           {` ${lang.label} ( ${t(lang.label)} ) `}
//                         </span>
//                         <span
//                           style={{ maxWidth: "10%" }}
//                           className={`${isSelected ? "d-block" : "d-none"}`}
//                         >
//                           <CheckOutlinedIcon />
//                         </span>
//                       </li>
//                     </MenuItem>
//                   );
//                 })}
//               </Menu>
//             </div>
//             <div>
//               {getLocalStorageMenuItem("theme") !== "costomize" && (
//                 <span className="ms-2 pt-0 cursor" onClick={hanldeMode}>
//                   {mode === "dark" ? (
//                     <DarkModeIcon className="mode-icon-dark" />
//                   ) : (
//                     <LightModeIcon className="mode-icon-light" />
//                   )}
//                 </span>
//               )}
//             </div>
//           </div>
//         </div>

//         {loadingTree && <Loading backColor={setMobileBackColor()} />}

//         <div className="p-24">
//           <div
//             className="rounded-4 m-top-12 pt-3 pb-3 px-3 alignByLang"
//             style={{
//               backgroundColor: setMobileBackColor(),
//               borderColor: setMobileCardBorderColor(),
//               borderWidth: 1,
//               borderStyle: "solid",
//             }}
//           >
//             {JSON.parse(params.get("t")) && (
//               <>
//                 <Badge
//                   onClick={() =>
//                     handleSendNotification(
//                       isMainMode ? "call waiter" : "",
//                       isMainMode
//                         ? "please call waiter for this table"
//                         : ""
//                     )
//                   }
//                   style={{
//                     borderRadius: "8px",
//                   }}
//                   className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
//                 >
//                   {t("Call Waiter")}
//                 </Badge>

//                 {detailsData?.notification_buttons_settings
//                   ?.notification_1_active && (
//                     <Badge
//                       onClick={() =>
//                         handleSendNotification(
//                           detailsData?.notification_buttons_settings
//                             ?.notification_1_title,
//                           detailsData?.notification_buttons_settings
//                             ?.notification_1_body
//                         )
//                       }
//                       style={{
//                         borderRadius: "8px",
//                       }}
//                       className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
//                     >
//                       {t(
//                         detailsData?.notification_buttons_settings
//                           ?.notification_1_button
//                       ) || ""}
//                     </Badge>
//                   )}

//                 {detailsData?.notification_buttons_settings
//                   ?.notification_2_active && (
//                     <Badge
//                       onClick={() =>
//                         handleSendNotification(
//                           detailsData?.notification_buttons_settings
//                             ?.notification_2_title,
//                           detailsData?.notification_buttons_settings
//                             ?.notification_2_body
//                         )
//                       }
//                       style={{
//                         borderRadius: "8px",
//                       }}
//                       className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
//                     >
//                       {t(
//                         detailsData?.notification_buttons_settings
//                           ?.notification_2_button
//                       ) || ""}
//                     </Badge>
//                   )}
//               </>
//             )}

//             <p className="m-top-12 cursor head-font" onClick={handleHome}>
//               {t("Home")}
//             </p>

//             {getLocalStorageMenuItem("mobileLoginToken") &&
//               getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
//               <p className="m-top-12 cursor head-font" onClick={handleProfile}>
//                 {t("My Profile")}
//               </p>
//             ) : (
//               ""
//             )}

//             <p
//               className="m-top-12 cursor head-font"
//               onClick={() => setOpenMyCards(true)}
//             >
//               <CreditCard fontSize="small" sx={{ mr: 1 }} />
//               {t("My Cards")}
//             </p>

//             {order_ability && getLocalStorageMenuItem("mobileLoginToken") ? (
//               <p onClick={handleOrders} className="cursor head-font">
//                 {t("My orders")}
//               </p>
//             ) : (
//               ""
//             )}

//             {getLocalStorageMenuItem("mobileLoginToken") &&
//               getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
//               <p className="m-top-12 cursor head-font" onClick={handleTransactions}>
//                 {t("Wallet")}
//               </p>
//             ) : (
//               ""
//             )}

//             <p className="m-top-12 cursor head-font" onClick={handleFavorites}>
//               {t("Favorites")}
//             </p>

//             <p onClick={handleFeedBack} className="cursor head-font">
//               {t("Your opinion Matters!")}
//             </p>

//             <p onClick={handlePrivacyPolicy} className="cursor head-font">
//               {t("Privacy Policy")}
//             </p>

//             <p onClick={handleTermsAndConditions} className="cursor head-font">
//               {t("Terms and Conditions")}
//             </p>

//             {getLocalStorageMenuItem("mobileLoginToken") &&
//               getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
//               <p onClick={handleLogout} className="cursor head-font">
//                 {t("Logout")}
//               </p>
//             ) : (
//               ""
//             )}
//           </div>
//         </div>
//         <div style={{ borderBottom: "1px solid #aaa" }}></div>


//         <ul className=" mt-4 bottom-0 start-0 w-100 d-flex justify-content-center list-unstyled">
//           {detailsData?.facebook && (
//             <li className="mx-2">
//               <img
//                 onClick={() => handleSocialPage(detailsData?.facebook)}
//                 src={ISDARKTHEME(
//                   getLocalStorageMenuItem("theme") ||
//                   detailsData?.mobile_settings?.theme,
//                   setMobileBackColor() ||
//                   detailsData?.mobile_settings?.colorProps?.back
//                 ) ? FacebookDarkTheme : Facebook}
//                 alt="Facebook icon"
//                 className="cursor"
//               />
//             </li>
//           )}
//           {detailsData?.public_whatsapp && (
//             <li className="mx-2">
//               <img
//                 style={{ width: "20px", height: "20px" }}
//                 onClick={() => handleSocialPage(detailsData?.public_whatsapp)}
//                 src={ISDARKTHEME(
//                   getLocalStorageMenuItem("theme") ||
//                   detailsData?.mobile_settings?.theme,
//                   setMobileBackColor() ||
//                   detailsData?.mobile_settings?.colorProps?.back
//                 ) ? WhatsappDarkTheme : Whatsapp}
//                 alt="Whatsapp icon"
//                 className="cursor"
//               />
//             </li>
//           )}
//           {detailsData?.instagram && (
//             <li className="mx-2">
//               <img
//                 onClick={() => handleSocialPage(detailsData?.instagram)}
//                 src={ISDARKTHEME(
//                   getLocalStorageMenuItem("theme") ||
//                   detailsData?.mobile_settings?.theme,
//                   setMobileBackColor() ||
//                   detailsData?.mobile_settings?.colorProps?.back
//                 ) ? InstagramDarkTheme : Instagram}
//                 alt="Instagram icon"
//                 className="cursor"
//               />
//             </li>
//           )}
//           {detailsData?.twitter && (
//             <li className="mx-2">
//               <img
//                 onClick={() => handleSocialPage(detailsData?.twitter)}
//                 src={ISDARKTHEME(
//                   getLocalStorageMenuItem("theme") ||
//                   detailsData?.mobile_settings?.theme,
//                   setMobileBackColor() ||
//                   detailsData?.mobile_settings?.colorProps?.back
//                 ) ? TwitterDarkTheme : Twitter}
//                 alt="X icon"
//                 className="cursor"
//               />
//             </li>
//           )}
//           {detailsData?.snapchat && (
//             <li className="mx-2">
//               <img
//                 onClick={() => handleSocialPage(detailsData?.snapchat)}
//                 src={ISDARKTHEME(
//                   getLocalStorageMenuItem("theme") ||
//                   detailsData?.mobile_settings?.theme,
//                   setMobileBackColor() ||
//                   detailsData?.mobile_settings?.colorProps?.back
//                 ) ? SnapchatDarkTheme : Snapchat}
//                 alt="Snapchat icon"
//                 className="cursor"
//               />
//             </li>
//           )}
//           {detailsData?.website && (
//             <li className="mx-2">
//               <img
//                 onClick={() => handleSocialPage(detailsData?.website)}
//                 src={ISDARKTHEME(
//                   getLocalStorageMenuItem("theme") ||
//                   detailsData?.mobile_settings?.theme,
//                   setMobileBackColor() ||
//                   detailsData?.mobile_settings?.colorProps?.back
//                 ) ? GlobalDarkTheme : Global}
//                 alt="global icon"
//                 className="cursor"
//               />
//             </li>
//           )}
//           {detailsData?.tiktok && (
//             <li className="mx-2">
//               <img
//                 onClick={() => handleSocialPage(detailsData?.tiktok)}
//                 src={ISDARKTHEME(
//                   getLocalStorageMenuItem("theme") ||
//                   detailsData?.mobile_settings?.theme,
//                   setMobileBackColor() ||
//                   detailsData?.mobile_settings?.colorProps?.back
//                 ) ? Tiktok_Dark : Tiktok_Light}
//                 alt="tiktok icon"
//                 className="cursor"
//               />
//             </li>
//           )}
//         </ul>

//         <Typography
//           className="sub-font"
//           variant="body2"
//           style={{
//             color: setMobileTextColor(),
//             opacity: 0.7,
//             textAlign: 'center',
//             marginTop: '20px',
//             paddingBottom: "20px"

//           }}
//         >
//           © {new Date().getFullYear()} {t('Aurmenu')}. {t("All rights reserved")}
//         </Typography>
//       </div>


//     </Box>
//   );

//   const toggleDrawer = (anchor, open) => (event) => {
//     if (
//       event.type === "keydown" &&
//       (event.key === "Tab" || event.key === "Shift")
//     ) {
//       return;
//     }

//     setState({ ...state, [anchor]: open });
//   };

//   const openBar = () => {
//     setState({ right: true });
//   };

//   // Render the sections based on mode
//   const renderSections = () => {
//     if (isMainMode && mianSectionsData?.tree?.tree) {
//       return (
//         <ScrollMenu
//           variant="quilted"
//           cols={mianSectionsData?.tree?.tree.length}
//           scrollContainerClassName={`mt-2 mb-2 alignByLang ${isDesktop ? 'd-flex justify-content-center' : ''}`}
//         >
//           {mianSectionsData?.tree?.tree.map((section, index) => {
//             return (
//               <label
//                 key={section.id}
//                 ref={(el) => (sectionRefs.current[index] = el)}
//                 onClick={() => handleOnNavClick(index)}
//                 className="sections-list cursor p-2 mb-3 sub-font"
//                 style={{
//                   color:
//                     currentSectionId === index
//                       ? setMobileButttonBackColor()
//                       : setMobileTextColor(),
//                   borderColor:
//                     currentSectionId === index
//                       ? setMobileButttonBackColor()
//                       : setMobileTextColor(),
//                 }}
//               >
//                 {section.name}
//               </label>
//             );
//           })}
//         </ScrollMenu>
//       );
//     } else if (isSectionMode && mianSectionsData?.sections?.sections) {
//       return (
//         <ScrollMenu
//           variant="quilted"
//           cols={mianSectionsData?.sections?.sections.length}
//           className="mt-2 mb-2 alignByLang"
//         >
//           {mianSectionsData?.sections?.sections.map((section) => {
//             return (
//               <label
//                 key={section.id}
//                 onClick={() => handleParentSection(section)}
//                 className="sections-list cursor p-2 mb-3 sub-font"
//                 style={{
//                   color:
//                     currentId == section.id
//                       ? setMobileButttonBackColor()
//                       : setMobileTextColor(),
//                   borderColor:
//                     currentId == section.id
//                       ? setMobileButttonBackColor()
//                       : setMobileTextColor(),
//                 }}
//               >
//                 {section.name}
//               </label>
//             );
//           })}
//         </ScrollMenu>
//       );
//     }
//     return null;
//   };

//   const dialogStyles = {
//     backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor()[0],
//     color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
//     borderColor: setMobileTextField_BK_FONT_Border_StyleColor()[2],
//   };

//   return (
//     !languagesIsLoading &&
//     mianSectionsData && (
//       <div
//         className={`position-relative`}
//         style={{ backgroundColor: setMobileBackColor(), padding: isDesktop ? "10px" : "0px" }}
//       >
//         <MobileNavbar
//           toggleDrawer={toggleDrawer}
//           openBar={openBar}
//           logo={detailsData?.logo}
//           cover={detailsData?.cover}
//           desc={detailsData?.description}
//           parentId={parentId}
//           venueName={detailsData?.venu_name}
//           handleParent={handleParent}
//           backToMain={backToMain}
//           width={width}
//           label_name={label_name}
//           tableName={qrName}
//           tableQr={qrCode}
//           isDesktop={isDesktop}
//           isMobile={isMobile}
//         />

//         <ToastContainer />
//         <Backdrop
//           open={loading}
//           sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
//         >
//           <CircularProgress color="inherit" />
//         </Backdrop>

//         {!window.location.pathname.includes("/labels") && (
//           <div>
//             <div style={{ margin: "auto" }}>
//               {(mianSectionsData?.tree?.tree || mianSectionsData?.sections?.sections) && (
//                 <div
//                   className={`${isScrolled
//                     ? (getLocalStorageMenuItem("orderType") !== "" || JSON.parse(params.get("t"))) ? `top-fixed-sections-scroll_2` : `top-fixed-sections-scroll`
//                     : `top-fixed-sections`
//                     } sub-font alignByLang ${getLocalStorageMenuItem("mode") === "dark" ? "dark" : "light"
//                     }`}
//                   style={{
//                     margin: "auto",
//                     backgroundColor: setMobileBackColor(),
//                     width: width,
//                     alignContent: "center",
//                     alignItems: "center",

//                   }}
//                 >
//                   {renderSections()}
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         <Drawer
//           anchor={
//             getLocalStorageMenuItem("lang") === "ar" ||
//               getLocalStorageMenuItem("lang") === "fa"
//               ? "right"
//               : "left"
//           }
//           open={state["right"]}
//           onClose={toggleDrawer("right", false)}
//         >
//           {list("right")}
//         </Drawer>

//         <Toast
//           open={toastSettings.open}
//           message={toastSettings.message}
//           resetToast={handleCloseToast}
//           success={toastSettings.success}
//         />

//         <Dialog
//           open={showInfoDailog}
//           onClose={() => setShowInfoDailog(false)}
//           maxWidth="sm"
//           PaperProps={{
//             style: {
//               borderRadius: 15,
//               padding: "20px",
//               backgroundColor: dialogStyles.backgroundColor,
//               border: `1px solid ${setMobileCardBorderColor()}'}`,
//             },
//           }}
//         >
//           <DialogTitle sx={{ textAlign: "center", paddingBottom: 0 }}>
//             <Typography variant="h6" fontWeight="bold" color={setMobileTextColor()}>
//               {t("Hi")}
//             </Typography>
//           </DialogTitle>
//           <DialogContent>
//             <Box sx={{ display: "flex", justifyContent: "center", padding: "10px" }}>
//               <Typography variant="body1" textAlign="center" color={dialogStyles.color}>
//                 {t("Your order sent and it will be with you as sson as possible, Thank you.")}
//               </Typography>
//             </Box>
//           </DialogContent>
//           <DialogActions sx={{ justifyContent: "center" }}>
//             <Button
//               onClick={() => setShowInfoDailog(false)}
//               sx={{
//                 backgroundColor: setMobileCardBorderColor(),
//                 color: '#fff',
//                 padding: "8px 16px",
//                 borderRadius: "30px",
//                 "&:hover": {
//                   backgroundColor: setMobileCardBorderColor(),
//                 },
//               }}
//             >
//               {t("ok")}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         <Dialog
//           open={openMyCards}
//           onClose={() => {
//             setOpenMyCards(false);
//             setShowAddCard(false);
//           }}
//           fullWidth
//           maxWidth="sm"
//         >
//           <DialogTitle sx={{ textAlign: "center", fontWeight: 600 }}>
//             {t("My Cards")}
//           </DialogTitle>

//           <DialogContent>
//             {myCards?.length === 0 && (
//               <Typography sx={{ textAlign: "center", opacity: 0.7 }}>
//                 {t("No saved cards")}
//               </Typography>
//             )}

//             {myCards?.map((card, index) => (
//               <Box
//                 key={index}
//                 sx={{
//                   p: 2,
//                   mb: 1,
//                   border: "1px solid #ddd",
//                   borderRadius: 2,
//                 }}
//               >
//                 <Typography>
//                   **** **** **** {card.last4}
//                 </Typography>
//                 <Typography variant="caption">
//                   {card.brand}
//                 </Typography>
//               </Box>
//             ))}

//             <Button
//               fullWidth
//               sx={{ mt: 2 }}
//               variant="contained"
//               onClick={() => {
//                 setShowAddCard(true);
//                 setTimeout(initSaveCardPixel, 0);
//               }}
//             >
//               {t("Add New Card")}
//             </Button>

//             {showAddCard && (
//               <Box
//                 id="paymob-save-card-container"
//                 sx={{
//                   mt: 2,
//                   minHeight: 420,
//                   border: "1px solid #ddd",
//                   borderRadius: 2,
//                   backgroundColor: "#fff",
//                 }}
//               />
//             )}
//           </DialogContent>
//         </Dialog>

//       </div>
//     )
//   );
// };

// export default Top;


import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import Pusher from "pusher-js";
import MobileNavbar from "../mobileNavbar";
import React, { useEffect, useRef, useState } from "react";
import noImageAvailable from "../../../images/No_Image_Available.jpg";
import {
  FCM_TOKEN,
  fetchWalletBalance,
  getAuthMobile,
  getGustAuthMobile,
  getLocalStorageMenuItem,
  ISDARKTHEME,
  sendNotificationFirebaseRes,
  setLocalStorageMenuItem,
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileTextColor,
  setMobileTextField_BK_FONT_Border_StyleColor,
} from "../../../utility";
import axios from "axios";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import Snapchat from "../../../images/snapchat.svg";
import Facebook from "../../../images/facebook-icon.svg";
import Twitter from "../../../images/twitter.svg";
import Instagram from "../../../images/instigram.svg";
import Global from "../../../images/global.svg";

import FacebookDarkTheme from "../../../images/facebook-icon-dark-theme.svg";
import TwitterDarkTheme from "../../../images/x-icon-dark-theme.svg";
import InstagramDarkTheme from "../../../images/insta-icon-dark-theme.svg";
import WhatsappDarkTheme from "../../../images/whatsapp-icon-dark-theme.svg";
import MapDarkTheme from "../../../images/map-dark-icon-theme.svg";
import GlobalDarkTheme from "../../../images/global-icon-dark-theme.svg";
import Tiktok_Dark from "../../../images/tiktok_dark.svg";
import Whatsapp from "../../../images/whatsapp.svg";
import SnapchatDarkTheme from "../../../images/snap-icon-dark-theme.svg";
import Tiktok_Light from "../../../images/tiktok_light.svg";

import { CloseOutlined, TranslateOutlined } from "@mui/icons-material";
import { t } from "i18next";
import Loading from "../../../common/loading";
import { Badge } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import addNotification from "react-push-notification";
import Toast from "../../../common/toast";

const Top = ({
  qrCode,
  qrName,
  updateTreeData,
  handleLanguage,
  currentId,
  parentId,
  currentSectionId,
  mianSectionsData,
  detailsData,
  lablesData,
  handleOnClick,
  handleParentSection,
  handleParent,
  backToMain,
  width,
  order_ability,
  label_name,
  itemsRefetch,
  isMobile,
  isDesktop
}) => {
  const mode = getLocalStorageMenuItem("theme");
  const language = getLocalStorageMenuItem("lang");
  const [isScrolled, setIsScrolled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({ right: false });
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const sectionRefs = useRef([]);

  const [anchorlang, setAnchorlang] = useState(null);
  const openLang = Boolean(anchorlang);
  const [loadingTree, setLoadingTree] = useState(false);

  // Determine which mode we're in based on available props/data
  const isMainMode = mianSectionsData?.tree?.tree && handleOnClick;
  const isSectionMode = mianSectionsData?.sections?.sections && handleParentSection;

  const [customerBalance, setCustomerBalance] = useState(getLocalStorageMenuItem("customer_balance") || 0);

  const [showInfoDailog, setShowInfoDailog] = useState(false);

  const [toastSettings, setToastSettings] = useState({
    open: false,
    message: "",
    success: false,
  });

  const handleOpenToast = (message, state) => {
    setToastSettings({
      open: true,
      success: state,
      message: message
    });
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setToastSettings({ open: false, message: "", success: false });
  };

  const handleClickLang = (event) => {
    setAnchorlang(event.currentTarget);
  };

  const handleCloseLang = () => {
    setAnchorlang(null);
  };

  const getDeviceType = () => {
    const userAgent = navigator.userAgent;
    if (/iPhone/i.test(userAgent)) {
      return "iPhone";
    } else if (/Android/i.test(userAgent)) {
      return "Android";
    } else {
      return "Other";
    }
  };

  const handleOnNavClick = (index) => {
    if (handleOnClick) {
      handleOnClick(index);
    }
  };



  useEffect(() => {
    const deviceType = getDeviceType();
    const handleScroll = () => {
      if (sectionRefs.current[currentSectionId]) {
        sectionRefs.current[currentSectionId].scrollIntoView({
          behavior: "smooth",
          inline: "center",
        });
      }
    };

    if (deviceType === "iPhone") {
      if (sectionRefs.current[currentSectionId]) {
        sectionRefs.current[currentSectionId].scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    } else {
      if (sectionRefs.current[currentSectionId]) {
        sectionRefs.current[currentSectionId].scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    }
  }, [currentSectionId, sectionRefs]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const pusher = new Pusher("ae14bac927c237af424c", {
      cluster: "mt1",
      auth: getGustAuthMobile(),
    });

    const channel = pusher.subscribe(
      `customer_notifications.${getLocalStorageMenuItem("gustToken")}`
    );

    channel.bind("App\\Events\\NotificationRespond", (data) => {
      addNotification({
        title: data.title,
        message: data.message,
        duration: 8000,
        icon: detailsData?.logo || noImageAvailable,
        native: true,
      });
    });

    return () => {
      pusher.unsubscribe("customer_notifications");
      pusher.disconnect();
    };
  }, []);

  useEffect(() => {

    const fetchCust_Balance = async () => {
      const newBalance = await fetchWalletBalance();
      setCustomerBalance(newBalance);
    }

    fetchCust_Balance();

  }, [])

  const {
    data: languagesData,
    isLoading: languagesIsLoading,
    isError: LanguagesIsError,
    error: languagesError,
  } = useQuery("languages", () => {
    const timeZone = getLocalStorageMenuItem("timezone")
      ? getLocalStorageMenuItem("timezone")
      : "";

    try {
      return axios.get(
        `${process.env.REACT_APP_API}/menus/${qrCode}/public-languages`,
        {
          headers: {
            localization: getLocalStorageMenuItem("lang"),
            timeZone: timeZone.replace(/["]+/g, ""),
          },
        }
      );
    } catch (error) { }
  });

  useEffect(() => {
    const validateLanguage = () => {
      if (languagesData?.data?.data?.languages?.length > 0) {
        const availableLanguages = languagesData.data.data.languages.map(lang => lang.code);
        const currentLanguage = getLocalStorageMenuItem("lang");

        // If current language is not in available languages, set to first available language
        if (!availableLanguages.includes(currentLanguage)) {
          const firstLanguage = availableLanguages[0];
          setLocalStorageMenuItem("lang", firstLanguage);
          handleLanguagedata(firstLanguage);
        }
      }
    };

    if (languagesData && !languagesIsLoading) {
      validateLanguage();
    }
  }, [languagesData, languagesIsLoading]);

  const handleFeedBack = () => {
    navigate(
      `/${qrName}/${qrCode}/feedback?section=${currentId}&t=${params.get("t")}`
      , {
        replace: true
      });
  };

  const handlePrivacyPolicy = () => {
    navigate(`/${qrName}/${qrCode}/privacy-policy`, {
      replace: true
    });
  };

  const handleTermsAndConditions = () => {
    navigate(`/${qrName}/${qrCode}/terms-and-conditions`, {
      replace: true
    });
  };

  const handleHome = () => {
    const baseUrl = `/${qrName}/${qrCode}/menus?lang=${language}`;
    const tableParam = params.get("t");
    navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl, {
      replace: true
    });
  };

  const handleProfile = () => {
    const baseUrl = `/${qrName}/${qrCode}/profile?lang=${language}`;
    const tableParam = params.get("t");
    navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl, {
      replace: true
    });
  };

  const handleLogout = async () => {
    await setLocalStorageMenuItem("mobileLoginToken", "");
    const baseUrl = `/${qrName}/${qrCode}/menus?lang=${language}`;
    const tableParam = params.get("t");
    navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl, {
      replace: true
    });
  };

  const handleFavorites = () => {
    navigate(
      `/${qrName}/${qrCode}/favorites?section=${currentId}&t=${params.get("t")}`
      , {
        replace: true
      });
  };

  const handleOrders = () => {
    navigate(
      `/${qrName}/${qrCode}/orders?section=${currentId}&t=${params.get(
        "t"
      )}&lang=${language}`
      , {
        replace: true
      });
  };

  const handleTransactions = () => {
    navigate(
      `/${qrName}/${qrCode}/transactions?section=${currentId}&t=${params.get(
        "t"
      )}&lang=${language}`
      , {
        replace: true
      });
  }

  const onImageError = (e) => {
    e.target.src = noImageAvailable;
  };

  const hanldeMode = () => {
    if (getLocalStorageMenuItem("theme") === "dark") {
      setLocalStorageMenuItem("theme", "light");
      params.set("theme", "light");
      setParams(params);
    } else {
      setLocalStorageMenuItem("theme", "dark");
      params.set("theme", "dark");
      setParams(params);
    }
  };

  const handleSocialPage = (page) => {
    window.open(page, "_blank");
  };

  const handleLanguagedata = async (langCode) => {
    setLoadingTree(true);
    try {
      const timeZone = getLocalStorageMenuItem("timezone") || "";
      const promise = await axios.get(
        `${process.env.REACT_APP_API}/menus/${qrCode}/public-tree?table=${params.get('t') || null}`,
        {
          headers: {
            localization: langCode,
            timeZone: timeZone.replace(/["]+/g, ""),
          },
        }
      );
      await setLocalStorageMenuItem(
        "tree_data",
        JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
      );
      await updateTreeData(promise?.data?.data || []);

      handleLanguage(langCode);
      itemsRefetch();
    } catch (error) {
      // Handle error
    } finally {
      setLoadingTree(false);
    }
  };

  const handleSendNotification = async (title, body) => {
    setLoading(true);
    try {
      const sendNotificationRes = await axios.post(
        `${process.env.REACT_APP_API}/general-notification`,
        {
          venue_id: detailsData?.venue_id,
          title: title || "",
          message: body || "",
          table: params.get("t") || "",
        }
      );

      const sendNotificationFirebase = await sendNotificationFirebaseRes(
        detailsData,
        title || "",
        body || "",
        "notifications"
      );

      if (
        sendNotificationRes?.data?.success &&
        sendNotificationFirebase?.data?.success
      ) {
        setLoading(false);

        // handleOpenToast(
        //   <div className="alignByLang">
        //     {t("Your notification sent successfully")}
        //   </div>
        //   , true);

        setShowInfoDailog(true);
      } else {
        setLoading(false);

        handleOpenToast(
          <div className="alignByLang">
            {t("Error while sending the notification.")}
          </div>
          , false);
      }
    } catch (error) {
      setLoading(false);

      handleOpenToast(
        <div className="alignByLang">
          {t("Error while sending the notification.") + " " + error.message}
        </div>
        , false);
    }
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 350 }}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div
        className={`mobile-side-bar min-vh-100`}
        style={{
          color: setMobileTextColor(),
          backgroundColor: setMobileCardColor(),
        }}
      >
        <div className="d-flex justify-content-between mobile-side-bar-top-settings p-4 sub-font">


          <div>
            <img
              src={detailsData?.logo || noImageAvailable}
              alt="logo"
              style={{ border: `4px solid ${setMobileCardColor()} ` }}
              className="mobile-side-bar-logo"
              onError={onImageError}
            />
            {/* Add name and balance from localStorage */}

            {getLocalStorageMenuItem("mobileLoginToken") && (
              <div className="mt-2 text-center" style={{ color: setMobileTextColor() }}>
                <div className="sub-font alignByLang text-center">
                  {t("Welcome")} {getLocalStorageMenuItem("customer_name")}
                </div>
                <div className="sub-font alignByLang text-center">
                  {t("Your Balance")} : {getLocalStorageMenuItem("customer_balance") || 0}
                </div>
              </div>
            )}
          </div>


          <div className="d-flex justify-content-between">
            <div>
              <span
                className="mx-2 pt-0 cursor"
                onClick={toggleDrawer(anchor, false)}
              >
                <CloseOutlined style={{ color: setMobileTextColor() }} />
              </span>
              <span className="mx-2 pt-0 cursor" onClick={handleClickLang}>
                <TranslateOutlined style={{ color: setMobileTextColor() }} />
              </span>
              <Menu
                id="long-menu"
                MenuListProps={{
                  "aria-labelledby": "long-button",
                }}
                anchorEl={anchorlang}
                open={openLang}
                onClose={handleCloseLang}
                onClick={handleCloseLang}
                PaperProps={{
                  style: {
                    maxHeight: 48 * 4.5,
                    width: "25ch",
                    backgroundColor: setMobileBackColor(),
                  },
                }}
              >

                {languagesData?.data?.data?.languages?.map((lang) => {
                  const currentLang = getLocalStorageMenuItem("lang");
                  const isSelected = lang.code === currentLang;

                  return (
                    <MenuItem
                      key={lang.code}
                      onClick={() => handleLanguagedata(lang.code)}
                    >
                      <li
                        className="d-flex justify-content-between align-items-center p-1 sub-font"
                        style={{
                          color: isSelected
                            ? setMobileButttonBackColor()
                            : setMobileTextColor(),
                        }}
                      >
                        <span style={{ maxWidth: "80%" }}>
                          {` ${lang.label} ( ${t(lang.label)} ) `}
                        </span>
                        <span
                          style={{ maxWidth: "10%" }}
                          className={`${isSelected ? "d-block" : "d-none"}`}
                        >
                          <CheckOutlinedIcon />
                        </span>
                      </li>
                    </MenuItem>
                  );
                })}
              </Menu>
            </div>
            <div>
              {getLocalStorageMenuItem("theme") !== "costomize" && (
                <span className="ms-2 pt-0 cursor" onClick={hanldeMode}>
                  {mode === "dark" ? (
                    <DarkModeIcon className="mode-icon-dark" />
                  ) : (
                    <LightModeIcon className="mode-icon-light" />
                  )}
                </span>
              )}
            </div>
          </div>
        </div>

        {loadingTree && <Loading backColor={setMobileBackColor()} />}

        <div className="p-24">
          <div
            className="rounded-4 m-top-12 pt-3 pb-3 px-3 alignByLang"
            style={{
              backgroundColor: setMobileBackColor(),
              borderColor: setMobileCardBorderColor(),
              borderWidth: 1,
              borderStyle: "solid",
            }}
          >
            {JSON.parse(params.get("t")) && (
              <>
                <Badge
                  onClick={() =>
                    handleSendNotification(
                      isMainMode ? "call waiter" : "",
                      isMainMode
                        ? "please call waiter for this table"
                        : ""
                    )
                  }
                  style={{
                    borderRadius: "8px",
                  }}
                  className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
                >
                  {t("Call Waiter")}
                </Badge>

                {detailsData?.notification_buttons_settings
                  ?.notification_1_active && (
                    <Badge
                      onClick={() =>
                        handleSendNotification(
                          detailsData?.notification_buttons_settings
                            ?.notification_1_title,
                          detailsData?.notification_buttons_settings
                            ?.notification_1_body
                        )
                      }
                      style={{
                        borderRadius: "8px",
                      }}
                      className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
                    >
                      {t(
                        detailsData?.notification_buttons_settings
                          ?.notification_1_button
                      ) || ""}
                    </Badge>
                  )}

                {detailsData?.notification_buttons_settings
                  ?.notification_2_active && (
                    <Badge
                      onClick={() =>
                        handleSendNotification(
                          detailsData?.notification_buttons_settings
                            ?.notification_2_title,
                          detailsData?.notification_buttons_settings
                            ?.notification_2_body
                        )
                      }
                      style={{
                        borderRadius: "8px",
                      }}
                      className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
                    >
                      {t(
                        detailsData?.notification_buttons_settings
                          ?.notification_2_button
                      ) || ""}
                    </Badge>
                  )}
              </>
            )}

            <p className="m-top-12 cursor head-font" onClick={handleHome}>
              {t("Home")}
            </p>

            {getLocalStorageMenuItem("mobileLoginToken") &&
              getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
              <p className="m-top-12 cursor head-font" onClick={handleProfile}>
                {t("My Profile")}
              </p>
            ) : (
              ""
            )}

            {order_ability && getLocalStorageMenuItem("mobileLoginToken") ? (
              <p onClick={handleOrders} className="cursor head-font">
                {t("My orders")}
              </p>
            ) : (
              ""
            )}

            {getLocalStorageMenuItem("mobileLoginToken") &&
              getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
              <p className="m-top-12 cursor head-font" onClick={handleTransactions}>
                {t("Wallet")}
              </p>
            ) : (
              ""
            )}

            <p className="m-top-12 cursor head-font" onClick={handleFavorites}>
              {t("Favorites")}
            </p>

            <p onClick={handleFeedBack} className="cursor head-font">
              {t("Your opinion Matters!")}
            </p>

            <p onClick={handlePrivacyPolicy} className="cursor head-font">
              {t("Privacy Policy")}
            </p>

            <p onClick={handleTermsAndConditions} className="cursor head-font">
              {t("Terms and Conditions")}
            </p>

            {getLocalStorageMenuItem("mobileLoginToken") &&
              getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
              <p onClick={handleLogout} className="cursor head-font">
                {t("Logout")}
              </p>
            ) : (
              ""
            )}
          </div>
        </div>
        <div style={{ borderBottom: "1px solid #aaa" }}></div>


        <ul className=" mt-4 bottom-0 start-0 w-100 d-flex justify-content-center list-unstyled">
          {detailsData?.facebook && (
            <li className="mx-2">
              <img
                onClick={() => handleSocialPage(detailsData?.facebook)}
                src={ISDARKTHEME(
                  getLocalStorageMenuItem("theme") ||
                  detailsData?.mobile_settings?.theme,
                  setMobileBackColor() ||
                  detailsData?.mobile_settings?.colorProps?.back
                ) ? FacebookDarkTheme : Facebook}
                alt="Facebook icon"
                className="cursor"
              />
            </li>
          )}
          {detailsData?.public_whatsapp && (
            <li className="mx-2">
              <img
                style={{ width: "20px", height: "20px" }}
                onClick={() => handleSocialPage(detailsData?.public_whatsapp)}
                src={ISDARKTHEME(
                  getLocalStorageMenuItem("theme") ||
                  detailsData?.mobile_settings?.theme,
                  setMobileBackColor() ||
                  detailsData?.mobile_settings?.colorProps?.back
                ) ? WhatsappDarkTheme : Whatsapp}
                alt="Whatsapp icon"
                className="cursor"
              />
            </li>
          )}
          {detailsData?.instagram && (
            <li className="mx-2">
              <img
                onClick={() => handleSocialPage(detailsData?.instagram)}
                src={ISDARKTHEME(
                  getLocalStorageMenuItem("theme") ||
                  detailsData?.mobile_settings?.theme,
                  setMobileBackColor() ||
                  detailsData?.mobile_settings?.colorProps?.back
                ) ? InstagramDarkTheme : Instagram}
                alt="Instagram icon"
                className="cursor"
              />
            </li>
          )}
          {detailsData?.twitter && (
            <li className="mx-2">
              <img
                onClick={() => handleSocialPage(detailsData?.twitter)}
                src={ISDARKTHEME(
                  getLocalStorageMenuItem("theme") ||
                  detailsData?.mobile_settings?.theme,
                  setMobileBackColor() ||
                  detailsData?.mobile_settings?.colorProps?.back
                ) ? TwitterDarkTheme : Twitter}
                alt="X icon"
                className="cursor"
              />
            </li>
          )}
          {detailsData?.snapchat && (
            <li className="mx-2">
              <img
                onClick={() => handleSocialPage(detailsData?.snapchat)}
                src={ISDARKTHEME(
                  getLocalStorageMenuItem("theme") ||
                  detailsData?.mobile_settings?.theme,
                  setMobileBackColor() ||
                  detailsData?.mobile_settings?.colorProps?.back
                ) ? SnapchatDarkTheme : Snapchat}
                alt="Snapchat icon"
                className="cursor"
              />
            </li>
          )}
          {detailsData?.website && (
            <li className="mx-2">
              <img
                onClick={() => handleSocialPage(detailsData?.website)}
                src={ISDARKTHEME(
                  getLocalStorageMenuItem("theme") ||
                  detailsData?.mobile_settings?.theme,
                  setMobileBackColor() ||
                  detailsData?.mobile_settings?.colorProps?.back
                ) ? GlobalDarkTheme : Global}
                alt="global icon"
                className="cursor"
              />
            </li>
          )}
          {detailsData?.tiktok && (
            <li className="mx-2">
              <img
                onClick={() => handleSocialPage(detailsData?.tiktok)}
                src={ISDARKTHEME(
                  getLocalStorageMenuItem("theme") ||
                  detailsData?.mobile_settings?.theme,
                  setMobileBackColor() ||
                  detailsData?.mobile_settings?.colorProps?.back
                ) ? Tiktok_Dark : Tiktok_Light}
                alt="tiktok icon"
                className="cursor"
              />
            </li>
          )}
        </ul>

        <Typography
          className="sub-font"
          variant="body2"
          style={{
            color: setMobileTextColor(),
            opacity: 0.7,
            textAlign: 'center',
            marginTop: '20px',
            paddingBottom: "20px"

          }}
        >
          © {new Date().getFullYear()} {t('Aurmenu')}. {t("All rights reserved")}
        </Typography>
      </div>


    </Box>
  );

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const openBar = () => {
    setState({ right: true });
  };

  // Render the sections based on mode
  const renderSections = () => {
    if (isMainMode && mianSectionsData?.tree?.tree) {
      return (
        <ScrollMenu
          variant="quilted"
          cols={mianSectionsData?.tree?.tree.length}
          scrollContainerClassName={`mt-2 mb-2 alignByLang ${isDesktop ? 'd-flex justify-content-center' : ''}`}
        >
          {mianSectionsData?.tree?.tree.map((section, index) => {
            return (
              <label
                key={section.id}
                ref={(el) => (sectionRefs.current[index] = el)}
                onClick={() => handleOnNavClick(index)}
                className="sections-list cursor p-2 mb-3 sub-font"
                style={{
                  color:
                    currentSectionId === index
                      ? setMobileButttonBackColor()
                      : setMobileTextColor(),
                  borderColor:
                    currentSectionId === index
                      ? setMobileButttonBackColor()
                      : setMobileTextColor(),
                }}
              >
                {section.name}
              </label>
            );
          })}
        </ScrollMenu>
      );
    } else if (isSectionMode && mianSectionsData?.sections?.sections) {
      return (
        <ScrollMenu
          variant="quilted"
          cols={mianSectionsData?.sections?.sections.length}
          className="mt-2 mb-2 alignByLang"
        >
          {mianSectionsData?.sections?.sections.map((section) => {
            return (
              <label
                key={section.id}
                onClick={() => handleParentSection(section)}
                className="sections-list cursor p-2 mb-3 sub-font"
                style={{
                  color:
                    currentId == section.id
                      ? setMobileButttonBackColor()
                      : setMobileTextColor(),
                  borderColor:
                    currentId == section.id
                      ? setMobileButttonBackColor()
                      : setMobileTextColor(),
                }}
              >
                {section.name}
              </label>
            );
          })}
        </ScrollMenu>
      );
    }
    return null;
  };

  const dialogStyles = {
    backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor()[0],
    color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
    borderColor: setMobileTextField_BK_FONT_Border_StyleColor()[2],
  };

  return (
    !languagesIsLoading &&
    mianSectionsData && (
      <div
        className={`position-relative`}
        style={{ backgroundColor: setMobileBackColor(), padding: isDesktop ? "10px" : "0px" }}
      >
        <MobileNavbar
          toggleDrawer={toggleDrawer}
          openBar={openBar}
          logo={detailsData?.logo}
          cover={detailsData?.cover}
          desc={detailsData?.description}
          parentId={parentId}
          venueName={detailsData?.venu_name}
          handleParent={handleParent}
          backToMain={backToMain}
          width={width}
          label_name={label_name}
          tableName={qrName}
          tableQr={qrCode}
          isDesktop={isDesktop}
          isMobile={isMobile}
        />

        <ToastContainer />
        <Backdrop
          open={loading}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        {!window.location.pathname.includes("/labels") && (
          <div>
            <div style={{ margin: "auto" }}>
              {(mianSectionsData?.tree?.tree || mianSectionsData?.sections?.sections) && (
                <div
                  className={`${isScrolled
                    ? (getLocalStorageMenuItem("orderType") !== "" || JSON.parse(params.get("t"))) ? `top-fixed-sections-scroll_2` : `top-fixed-sections-scroll`
                    : `top-fixed-sections`
                    } sub-font alignByLang ${getLocalStorageMenuItem("mode") === "dark" ? "dark" : "light"
                    }`}
                  style={{
                    margin: "auto",
                    backgroundColor: setMobileBackColor(),
                    width: width,
                    alignContent: "center",
                    alignItems: "center",

                  }}
                >
                  {renderSections()}
                </div>
              )}
            </div>
          </div>
        )}

        <Drawer
          anchor={
            getLocalStorageMenuItem("lang") === "ar" ||
              getLocalStorageMenuItem("lang") === "fa"
              ? "right"
              : "left"
          }
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
        >
          {list("right")}
        </Drawer>

        <Toast
          open={toastSettings.open}
          message={toastSettings.message}
          resetToast={handleCloseToast}
          success={toastSettings.success}
        />

        <Dialog
          open={showInfoDailog}
          onClose={() => setShowInfoDailog(false)}
          maxWidth="sm"
          PaperProps={{
            style: {
              borderRadius: 15,
              padding: "20px",
              backgroundColor: dialogStyles.backgroundColor,
              border: `1px solid ${setMobileCardBorderColor()}'}`,
            },
          }}
        >
          <DialogTitle sx={{ textAlign: "center", paddingBottom: 0 }}>
            <Typography variant="h6" fontWeight="bold" color={setMobileTextColor()}>
              {t("Hi")}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ display: "flex", justifyContent: "center", padding: "10px" }}>
              <Typography variant="body1" textAlign="center" color={dialogStyles.color}>
                {t("Your order sent and it will be with you as sson as possible, Thank you.")}
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={() => setShowInfoDailog(false)}
              sx={{
                backgroundColor: setMobileCardBorderColor(),
                color: '#fff',
                padding: "8px 16px",
                borderRadius: "30px",
                "&:hover": {
                  backgroundColor: setMobileCardBorderColor(),
                },
              }}
            >
              {t("ok")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  );
};

export default Top;
